import { Component, ViewContainerRef, inject, OnInit, ComponentRef, NgModule, Type } from '@angular/core';
import { SystemViewComponent } from './system-view.component';
import { SystemViewNewComponent } from './system-view-new/system-view-new.component';
import { LayoutVersionService, LayoutVersion } from '../services/layout-version.service';
import { CommonModule } from '@angular/common';

/**
 * Componente wrapper que carrega dinamicamente a versão correta do system-view
 * baseado na configuração do usuário
 */
@Component({
  selector: 'system-view-layout-selector',
  template: `<ng-container #container></ng-container>`,
  standalone: false
})
export class SystemViewLayoutSelectorComponent implements OnInit {
  private viewContainer = inject(ViewContainerRef);
  private layoutVersionService = inject(LayoutVersionService);
  private currentComponentType: Type<any> = null;

  ngOnInit(): void {
    this.loadLayoutComponent();

    // Monitora mudanças de versão do layout
    this.layoutVersionService.layoutVersion$.subscribe((version) => {
      this.loadLayoutComponent();
    });
  }

  /**
   * Carrega o componente correto baseado na versão do layout
   */
  private loadLayoutComponent(): void {
    const version = this.layoutVersionService.getCurrentLayoutVersion();

    // Define qual componente usar. 'vault' usa a moldura moderna (ng-zorro), igual
    // ao 'light_modern', porem com .theme-alternate + .vault-theme (paleta petroleo/
    // teal do temapi-theme); a CONCILIADORA tambem redireciona pra versao VAULT via
    // ConciliadoraVaultGuard. 'light'/'dark' usam a moldura Material antiga.
    const componentToLoad:Type<any> =
      (version === 'light_modern' || version === 'vault') ? SystemViewNewComponent : SystemViewComponent;

    // Mesma moldura: nada a recriar — a paleta é aplicada pelo próprio
    // componente via change()/reload()
    if (componentToLoad === this.currentComponentType) {
      return;
    }

    this.viewContainer.clear();
    this.currentComponentType = componentToLoad;

    // Cria uma instância do componente
    const componentRef: ComponentRef<SystemViewComponent | SystemViewNewComponent> =
      this.viewContainer.createComponent(componentToLoad);

  }
}
